import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import TvApkSettings from "./tabs/settings";
import TvApkFaqs from "./tabs/faqs";
import TvApkBanners from "./tabs/banners";

const TvApkManage = () => {

    const { id, projectId } = useParams();
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState("settings");

    const tabs = [
        {
            key: "settings",
            label: "Settings",
            icon: "bi bi-sliders"
        },
        {
            key: "faq",
            label: "FAQs",
            icon: "bi bi-question-circle"
        },
        {
            key: "banners",
            label: "Banners",
            icon: "bi bi-image"
        }
    ];

    return (

        <main
            id="main"
            className="main"
            style={{
                background: "#f8fafc",
                minHeight: "100vh",
                paddingBottom: "30px"
            }}
        >

            {/* Breadcrumb */}

            <nav
                aria-label="breadcrumb"
                style={{
                    marginBottom: "6px"
                }}
            >
                <ol
                    className="breadcrumb"
                    style={{
                        background: "transparent",
                        padding: "0",
                        margin: "0",
                        fontSize: "13px",
                        flexWrap: "wrap",
                        gap: "2px"
                    }}
                >

                    <li className="breadcrumb-item">
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                navigate("/masters/tvApkProjects");
                            }}
                            style={{
                                color: "#3b82f6",
                                textDecoration: "none",
                                fontWeight: "500"
                            }}
                        >
                            <i className="bi bi-grid me-1" />
                            Projects
                        </a>
                    </li>

                    <li className="breadcrumb-item">
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                navigate(`/projects/${projectId}/tvapks`);
                            }}
                            style={{
                                color: "#3b82f6",
                                textDecoration: "none",
                                fontWeight: "500"
                            }}
                        >
                            <i className="bi bi-tv me-1" />
                            TV APK List
                        </a>
                    </li>

                    <li
                        className="breadcrumb-item active"
                        aria-current="page"
                        style={{
                            color: "#64748b",
                            fontWeight: "500"
                        }}
                    >
                        <i className="bi bi-gear me-1" />
                        TV APK Management
                    </li>

                </ol>
            </nav>

            {/* Top Header */}

            <div
                className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4"
            >

                <div className="d-flex align-items-center gap-3">

                    {/* Back Button */}

                    <button
                        onClick={() => navigate(`/projects/${projectId}/tvapks`)}
                        className="btn d-flex align-items-center gap-2"
                        title="Back to TV APK List"
                        style={{
                            background: "#ffffff",
                            border: "1px solid #e2e8f0",
                            borderRadius: "10px",
                            padding: "9px 14px",
                            fontSize: "13px",
                            color: "#475569",
                            fontWeight: "500",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                            transition: "all 0.18s ease",
                            whiteSpace: "nowrap"
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#f1f5f9";
                            e.currentTarget.style.borderColor = "#94a3b8";
                            e.currentTarget.style.color = "#0f172a";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = "#ffffff";
                            e.currentTarget.style.borderColor = "#e2e8f0";
                            e.currentTarget.style.color = "#475569";
                        }}
                    >
                        <i className="bi bi-arrow-left" />
                        Back
                    </button>

                    <div>

                        <h3
                            className="mb-1 fw-semibold"
                            style={{
                                color: "#0f172a"
                            }}
                        >
                            TV APK Management
                        </h3>

                        <p
                            className="mb-0"
                            style={{
                                color: "#64748b",
                                fontSize: "14px"
                            }}
                        >
                            Manage settings, FAQs and banners
                        </p>

                    </div>

                </div>

                <div
                    style={{
                        background: "#ffffff",
                        border: "1px solid #e2e8f0",
                        borderRadius: "10px",
                        padding: "10px 14px",
                        fontSize: "13px",
                        color: "#475569",
                        fontWeight: "500"
                    }}
                >
                    APK ID : {id}
                </div>

            </div>

            {/* Main Card */}

            <div
                style={{
                    background: "#ffffff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "18px",
                    overflow: "hidden"
                }}
            >

                {/* Tabs */}

                <div
                    className="d-flex align-items-center gap-2 flex-wrap"
                    style={{
                        padding: "16px 20px",
                        borderBottom: "1px solid #e2e8f0",
                        background: "#fcfcfd"
                    }}
                >

                    {
                        tabs.map((tab) => {

                            const isActive =
                                activeTab === tab.key;

                            return (

                                <button
                                    key={tab.key}
                                    onClick={() =>
                                        setActiveTab(tab.key)
                                    }
                                    className="btn d-flex align-items-center"
                                    style={{
                                        border: isActive
                                            ? "1px solid #0f172a"
                                            : "1px solid #e2e8f0",
                                        background:
                                            isActive
                                                ? "#0f172a"
                                                : "#ffffff",
                                        color:
                                            isActive
                                                ? "#ffffff"
                                                : "#334155",
                                        borderRadius: "10px",
                                        padding: "10px 16px",
                                        fontWeight: "500",
                                        fontSize: "14px",
                                        boxShadow: "none"
                                    }}
                                >

                                    <i
                                        className={`${tab.icon} me-2`}
                                    />

                                    {tab.label}

                                </button>

                            );

                        })
                    }

                </div>

                {/* Content */}

                <div
                    style={{
                        padding: "24px",
                        minHeight: "600px"
                    }}
                >

                    {
                        activeTab === "settings" &&
                        <TvApkSettings tvApkId={id} />
                    }

                    {
                        activeTab === "faq" &&
                        <TvApkFaqs tvApkId={id} />
                    }

                    {
                        activeTab === "banners" &&
                        <TvApkBanners tvApkId={id} />
                    }

                </div>

            </div>

        </main>

    );

};

export default TvApkManage;